var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "40",
    cy: "40",
    r: "40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.26 50.1l-5.1-5.1a2.65 2.65 0 0 0-3.74.06l-2.57 2.58-.5-.29a25.55 25.55 0 0 1-6.18-4.47c-2.34-2.35-3.58-4.58-4.48-6.2l-.27-.5 1.72-1.72.85-.85a2.67 2.67 0 0 0 .06-3.76l-5.1-5.1a2.65 2.65 0 0 0-3.74.06l-1.43 1.45.03.04a8.33 8.33 0 0 0-1.7 4.21c-.68 5.6 1.87 10.7 8.79 17.64 9.56 9.58 17.27 8.86 17.6 8.82a8.6 8.6 0 0 0 4.2-1.71l.04.03 1.45-1.43a2.67 2.67 0 0 0 .07-3.76z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
});